import React from 'react';

const ContactSection = () => {
  return (
    <div>
      <div className="contact-wrapper">
        <h2 className="section-heading">Just Keep Let’s Talk</h2>
        <div className="contact-grid">
          {/* Left Form */}
          <form className="contact-form">
            <input type="text" placeholder="Name" required />
            <input type="email" placeholder="Email" required />
            <input type="tel" placeholder="Mobile" required />
            <select required>
              <option value="">Select Service</option>
              <option value="mutual-funds">Mutual Funds</option>
              <option value="bonds">Bonds</option>
              <option value="loans">Loan Services</option>
            </select>
            <textarea placeholder="Message" rows="4"></textarea>
            <button type="submit" className="callback-btn">Request a Callback</button>

            <p><span>📧</span> <a href="mailto:info@gpsfinvest.com">info@gpsfinvest.com</a></p>
            <p><span>📞</span> <a href="tel:+919000XXXXXX">+91-9000-1234-123</a></p>

          </form>


          {/* Right Map & Info */}
          <div className="contact-map-info">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14690.377887249966!2d72.52986425!3d23.001935200000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1747832878582!5m2!1sen!2sin"
              width="600"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Map"
            ></iframe>

            &nbsp;

            {/* <div className="contact-details">
            <p><span>📍</span> GPS Finvest Pvt Ltd</p>
            <p><span>📧</span> <a href="mailto:info@gpsfinvest.com">info@gpsfinvest.com</a></p>
            <p><span>📞</span> +91-9000-XXX-XXX</p>
            <p><span>🕒</span> Mon–Sat, 10 AM – 7</p>
          </div> */}
          </div>
        </div>

        {/* Newsletter Section */}


      </div>
      <div className="newsletter-container">
        <h2 className="newsletter-heading">Stay Up to Date</h2>
        <p className="newsletter-subtext">
          Join our newsletter for weekly tips on smarter investments, new fund launches, and expert opinions.
        </p>
        <form className="newsletter-form">
          <input type="email" placeholder="Enter your email" required />
          <button type="submit" className="btn btn-primary my-4">Subscribe</button>
        </form>
        <p className="privacy-note">We respect your privacy. No spam, ever.</p>
      </div>
    </div>
  );
};

export default ContactSection;
